



import { Component, Vue, Watch } from "vue-property-decorator";
import ReportTilesMobile from "@/components/ReportTilesMobile.vue";
import GlobalFilterSensitiveMixin from '@/mixins/GlobalFilterSensitiveMixin';
import { NavigationGuardNext, Route } from "vue-router/types/router";

@Component({
  components: {
    ReportTilesMobile,
  },
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    next((vm: Vue) => {
      const that = vm as ReportsMobile;
      that.showDatePicker = to.meta?.datePicker ?? false;
    });
  },
  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    if(!this.$refs.showDatePicker)
    {
      this.$store.dispatch("setShowDatePicker", true);
    }
    next();
  },
  mixins: [
    GlobalFilterSensitiveMixin
  ]
})
export default class ReportsMobile extends Vue {
  showDatePicker = false;

  @Watch("showDatePicker", { immediate: true })
  showDatePickerChanged(fresh: boolean) {
    this.showDatePicker = fresh;
    this.$store.dispatch("setShowDatePicker", fresh);
  }
}
